import Duck from "redux-ducks-ts"

export const remenders = new Duck("remenders", "cargo")
